const SPACES_CLUSTER = {
    mini_site: {
        logo: {
            alt: 'monday spaces',
            url: 'https://mondayspaces.com',
            src: 'https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/GalBulka/space%20logo%20-%20Generator/spaces_open.png',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/GalBulka/space%20logo%20-%20Generator/spaces_open.png',
            useDesktopLogoInMobile: 'true',
        },
        unifiedDesktopLogo: {
            src: 'https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/GalBulka/space%20logo%20-%20Generator/desktop_close_monday_spaces_logo.png',
            alt: 'monday spaces',
            url: 'https://mondayspaces.com',
        },
    },
};

export { SPACES_CLUSTER };
